/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentInfoResponsePaymentGateway } from './PaymentInfoResponsePaymentGateway';
import {
    PaymentInfoResponsePaymentGatewayFromJSON,
    PaymentInfoResponsePaymentGatewayFromJSONTyped,
    PaymentInfoResponsePaymentGatewayToJSON,
    PaymentInfoResponsePaymentGatewayToJSONTyped,
} from './PaymentInfoResponsePaymentGateway';
import type { PaymentInfoResponseWireTransfer } from './PaymentInfoResponseWireTransfer';
import {
    PaymentInfoResponseWireTransferFromJSON,
    PaymentInfoResponseWireTransferFromJSONTyped,
    PaymentInfoResponseWireTransferToJSON,
    PaymentInfoResponseWireTransferToJSONTyped,
} from './PaymentInfoResponseWireTransfer';

/**
 * 
 * @export
 * @interface PaymentInfoResponse
 */
export interface PaymentInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentInfoResponse
     */
    isPaid: boolean;
    /**
     * Price in cents (1/100 of base unit of currency)
     * @type {number}
     * @memberof PaymentInfoResponse
     */
    totalAmountInCents: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResponse
     */
    paymentType: PaymentInfoResponsePaymentTypeEnum;
    /**
     * 
     * @type {PaymentInfoResponseWireTransfer}
     * @memberof PaymentInfoResponse
     */
    wireTransfer: PaymentInfoResponseWireTransfer | null;
    /**
     * 
     * @type {PaymentInfoResponsePaymentGateway}
     * @memberof PaymentInfoResponse
     */
    paymentGateway: PaymentInfoResponsePaymentGateway | null;
}


/**
 * @export
 */
export const PaymentInfoResponsePaymentTypeEnum = {
    Card: 'card',
    WireTransfer: 'wire-transfer',
    GoodHabit: 'good-habit',
    PaymentTerminal: 'payment-terminal'
} as const;
export type PaymentInfoResponsePaymentTypeEnum = typeof PaymentInfoResponsePaymentTypeEnum[keyof typeof PaymentInfoResponsePaymentTypeEnum];


/**
 * Check if a given object implements the PaymentInfoResponse interface.
 */
export function instanceOfPaymentInfoResponse(value: object): value is PaymentInfoResponse {
    if (!('isPaid' in value) || value['isPaid'] === undefined) return false;
    if (!('totalAmountInCents' in value) || value['totalAmountInCents'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    if (!('wireTransfer' in value) || value['wireTransfer'] === undefined) return false;
    if (!('paymentGateway' in value) || value['paymentGateway'] === undefined) return false;
    return true;
}

export function PaymentInfoResponseFromJSON(json: any): PaymentInfoResponse {
    return PaymentInfoResponseFromJSONTyped(json, false);
}

export function PaymentInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isPaid': json['isPaid'],
        'totalAmountInCents': json['totalAmountInCents'],
        'paymentType': json['paymentType'],
        'wireTransfer': PaymentInfoResponseWireTransferFromJSON(json['wireTransfer']),
        'paymentGateway': PaymentInfoResponsePaymentGatewayFromJSON(json['paymentGateway']),
    };
}

export function PaymentInfoResponseToJSON(json: any): PaymentInfoResponse {
    return PaymentInfoResponseToJSONTyped(json, false);
}

export function PaymentInfoResponseToJSONTyped(value?: PaymentInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPaid': value['isPaid'],
        'totalAmountInCents': value['totalAmountInCents'],
        'paymentType': value['paymentType'],
        'wireTransfer': PaymentInfoResponseWireTransferToJSON(value['wireTransfer']),
        'paymentGateway': PaymentInfoResponsePaymentGatewayToJSON(value['paymentGateway']),
    };
}

